import React from 'react';
import { motion } from 'framer-motion';
import { Shield } from 'lucide-react';
export function Guarantee() {
  return <section className="w-full bg-[#0a1410] py-8 md:py-16" data-id="element-126">
      <div className="max-w-4xl mx-auto px-4 sm:px-6" data-id="element-127">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="bg-[#0f1f17] border border-amber-900/30 rounded-lg p-6 md:p-12 text-center" data-id="element-128">
          <div className="flex justify-center mb-4 md:mb-6" data-id="element-129">
            <div className="bg-amber-500/10 p-4 rounded-full" data-id="element-130">
              <Shield className="w-12 h-12 text-amber-500" data-id="element-131" />
            </div>
          </div>

          <h2 className="text-3xl md:text-4xl font-bold text-white mb-4 md:mb-6" data-id="element-132">
            🛡️ GARANTÍA 7 DÍAS — SIN PREGUNTAS
          </h2>

          <p className="text-lg text-gray-300 mb-4 md:mb-6 leading-relaxed" data-id="element-133">
            Abrís los tomos. Los usás con tus pacientes. Si en 7 días no es lo
            que esperabas: devolución del 100% — sin formularios, sin drama.
          </p>

          <p className="text-xl font-bold text-amber-500" data-id="element-134">
            Tasa de devoluciones: menos del 1%.
          </p>
        </motion.div>
      </div>
    </section>;
}